module.exports = __webpack_public_path__ + "static/media/unsupported_device_browser.070fa753.svg";